import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function MentionsLegalesPage() {
  return (
    <>
      <Helmet>
        <title>Mentions Légales – TrackVibes</title>
        <meta name="description" content="Mentions légales de TrackVibes. Informations sur l'éditeur et l'hébergement du site." />
      </Helmet>
      
      <div className="min-h-screen bg-white">
        <div className="max-w-[900px] mx-auto px-6 py-12">
          {/* Logo */}
          <div className="text-center mb-12">
            <Link to="/">
              <img 
                src="/assets/trackvibes-logo.png" 
                alt="TrackVibes" 
                className="h-16 mx-auto"
              />
            </Link>
          </div>

          {/* Content */}
          <article className="prose prose-gray max-w-none">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Mentions Légales</h1>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">Éditeur</h2>
              <p className="text-gray-700 leading-relaxed">
                M. LASLEDJ<br />
                Auto entrepreneur<br />
                Siret : 799 191 093 00027<br />
                Châtenay-sur-Seine (77), France<br />
                Email : <a href="mailto:contact@trackvibes.app" className="text-blue-600 hover:underline">contact@trackvibes.app</a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">Hébergement</h2>
              <p className="text-gray-700 leading-relaxed">
                Cloudflare, Inc.<br />
                101 Townsend Street<br />
                San Francisco, CA 94107<br />
                États-Unis
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">Paiements</h2>
              <p className="text-gray-700 leading-relaxed">
                Stripe Payments Europe Ltd.<br />
                1 Grand Canal Street Lower<br />
                Grand Canal Dock<br />
                Dublin, Irlande
              </p>
            </section>
          </article>

          {/* Footer */}
          <footer className="mt-16 pt-8 border-t border-gray-200">
            <nav className="flex justify-center gap-6 text-sm text-gray-600">
              <Link to="/privacy" className="hover:text-gray-900">Confidentialité</Link>
              <span className="text-gray-300">|</span>
              <Link to="/conditions" className="hover:text-gray-900">Conditions</Link>
              <span className="text-gray-300">|</span>
              <Link to="/mentions-legales" className="hover:text-gray-900 font-medium">Mentions légales</Link>
            </nav>
            <p className="text-center text-gray-400 text-xs mt-4">© 2026 TrackVibes. Tous droits réservés.</p>
          </footer>
        </div>
      </div>
    </>
  );
}
